// Full Terms & Conditions viewer.
//
// Two modes:
//   - As an inline section (when shown in a page like Settings).
//   - As a modal (passed `onClose` — clicking close calls it).
//
// Renders all TERMS_SECTIONS expanded (no accordion) so users can scroll
// through the entire document. Required by Indian consumer-protection
// best practice — collapsible sections can be argued to hide material
// terms.

import React, { useContext } from "react";
import Ctx from "../../contexts/AppContext";
import { crd, sp, rad } from "../../constants/styles";
import { TERMS_VERSION, TERMS_EFFECTIVE_DATE, TERMS_SECTIONS, COMPANY_NAME } from "../../utils/terms";

export default function TermsView({ onClose, embedded = false }) {
    const { h, t } = useContext(Ctx);

    const content = (
        <div style={{ padding: embedded ? 0 : sp.lg, color: h.tx, fontSize: 13, lineHeight: 1.7 }}>
            <div style={{ textAlign: "center", marginBottom: sp.lg, paddingBottom: sp.md, borderBottom: `1px solid ${h.bd}` }}>
                <h1 style={{ color: h.tx, fontSize: 22, fontWeight: 700, margin: 0, letterSpacing: "-0.3px" }}>
                    Terms & Conditions
                </h1>
                <div style={{ color: h.sc, fontSize: 12, marginTop: 6 }}>
                    {COMPANY_NAME} • Version {TERMS_VERSION} • Effective {TERMS_EFFECTIVE_DATE}
                </div>
            </div>

            {TERMS_SECTIONS.map(section => (
                <div key={section.id} style={{ marginBottom: sp.lg }}>
                    <h2 style={{ color: h.tx, fontSize: 15, fontWeight: 700, margin: "0 0 8px", letterSpacing: "-0.1px" }}>
                        {section.title}
                    </h2>
                    {section.body.map((para, i) => (
                        <p key={i} style={{ color: h.tx, fontSize: 13, lineHeight: 1.7, margin: "0 0 10px" }}>
                            {para}
                        </p>
                    ))}
                </div>
            ))}

            <div style={{
                marginTop: sp.xl, padding: sp.md, borderRadius: rad.sm,
                background: `${h.ac}08`, border: `1px solid ${h.ac}30`,
                fontSize: 11, color: h.sc, lineHeight: 1.6
            }}>
                Last reviewed: {TERMS_EFFECTIVE_DATE}. By creating an account or
                continuing to use the Service after a material update, you accept
                the current version of these Terms.
            </div>
        </div>
    );

    if (embedded) return content;

    // Modal mode
    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
                zIndex: 1000, display: "flex", alignItems: "center",
                justifyContent: "center", padding: sp.md
            }}>
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    background: h.bg, borderRadius: rad.lg, width: "100%",
                    maxWidth: 600, maxHeight: "90vh", overflow: "hidden",
                    display: "flex", flexDirection: "column",
                    boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
                }}>
                <div style={{
                    padding: "12px 16px", borderBottom: `1px solid ${h.bd}`,
                    display: "flex", justifyContent: "space-between",
                    alignItems: "center", flexShrink: 0
                }}>
                    <strong style={{ color: h.tx, fontSize: 14 }}>Terms & Conditions</strong>
                    <button
                        onClick={onClose}
                        style={{
                            background: `${h.bd}50`, border: "none", width: 28,
                            height: 28, borderRadius: 14, color: h.tx, cursor: "pointer",
                            fontWeight: 700, display: "flex", alignItems: "center",
                            justifyContent: "center"
                        }}>✕</button>
                </div>
                <div style={{ overflow: "auto", flex: 1 }}>
                    {content}
                </div>
                {onClose && (
                    <div style={{
                        padding: sp.md, borderTop: `1px solid ${h.bd}`,
                        flexShrink: 0, display: "flex", justifyContent: "flex-end"
                    }}>
                        <button
                            onClick={onClose}
                            style={{
                                background: h.ac, color: "#fff", border: "none",
                                padding: "10px 20px", borderRadius: rad.sm,
                                fontSize: 13, fontWeight: 600, cursor: "pointer"
                            }}>{t.close || "Close"}</button>
                    </div>
                )}
            </div>
        </div>
    );
}
